<template>
  <div>
    <AgreementComponets></AgreementComponets>
    <!-- ネイティブからJSを実行して洗車TOPへ戻るために、クエリパラメータを格納する。 -->
    <input id="tsid" type="hidden" name="tsid" v-bind:value="this.$route.query.tsid">
    <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.$route.query.popinfoid">
    <input id="otoken" type="hidden" name="otoken" v-bind:value="this.$route.query.otoken">
    <input id="authid" type="hidden" name="authid" v-bind:value="this.$route.query.authid">
    <input id="ss_code" type="hidden" name="ss_code" v-bind:value="this.$route.query.ss_code">
    <input id="x_cls_app_version" type="hidden" name="x_cls_app_version" v-bind:value="this.$route.query.x_cls_app_version">
    <input id="x_cls_os" type="hidden" name="x_cls_os" v-bind:value="this.$route.query.x_cls_os">
    <input id="x_cls_os_version" type="hidden" name="x_cls_os_version" v-bind:value="this.$route.query.x_cls_os_version">
    <input id="dpi" type="hidden" name="dpi" v-bind:value="this.$route.query.dpi">
    <input id="device_pixel_ratio" type="hidden" name="device_pixel_ratio" v-bind:value="this.$route.query.device_pixel_ratio">
  </div>
</template>

<script>
import AgreementComponets from '@/components/Agreement'

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // [eventTrack]
    this.nativePVset('CARWASH_KIYAKU')
  },
  components: {
    AgreementComponets
  }
}
</script>
